import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';

const Page = ({ children, className, loading, referenceLoading, title, ...props }) => {
  const hasLoadingItems = referenceLoading.get('itemsStarted') > 0;
  const isLoading = hasLoadingItems && referenceLoading.get('itemsStarted') !== referenceLoading.get('itemsFinished');

  const classes = classNames(className, 'Page');
  const contentWrapperClasses = classNames('page--inner-wrapper', {
    'has-loading-items': hasLoadingItems,
    loading: isLoading,
  });

  return (
    <div className={classes}>
      <div className={contentWrapperClasses}>
        {children}
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    referenceLoading: state.getIn(['ui', 'referenceLoading']),
  };
}

export default connect(mapStateToProps)(Page);
